import BookingDetails from "../venueManager/BookingDetails";
import VenueDashboard from "../venueManager/Dashboard";
import VenueManagerDashboard from "../venueManager/VenueManagerDashboard"
import BookingList from "../venueManager/BookingList";
import EventBooking from "../venueManager/EventBookings";
import TicketDetails from "../venueManager/TIcketDetails";
import MyEvents from "../venueManager/MyEvents";
import BookForOthers from "../venueManager/BookForOthers.jsx/Index"
import PaymentSummary from "../venueManager/BookForOthers.jsx/PaymentSummary";
import BookingInformation from "../venueManager/BookForOthers.jsx/BookingInformation";
let id = localStorage.getItem("venueManagerBookingId");

export const allVenueManagerroutes = [
  {
    url: "",
    component: <VenueDashboard />,
  },
  {
    url: "venue-manager",
    component: <VenueManagerDashboard />,
  },
  {
    url: "event-manager",
    component: <VenueDashboard />,
  },

  {
    url: `booking-details/:id`,
    component: <BookingDetails />,
  },
  {
    url: "booking-list",
    component: <BookingList />,
  },
  {
    url: "event-booking",
    component: <EventBooking />,
  },
  {
    url: `ticket-details/:id`,
    component: <TicketDetails />,
  },
  {
    url: `my-events`,
    component: <MyEvents />
  },
  {
    url: "book-for-others",
    component: <BookForOthers />
  },
  {
    url: "payment-summary",
    component: <PaymentSummary />
  },
  {
    url: "manager-ticket-details",
    component: <BookingInformation />
  }
];
